<div class="skill-profile-container">
  @if (skillProfile) {
    <app-child-entity-manager [childEntityModel]="childEntities.skill" [panelMode]="false"
    [resource]="skillProfile"></app-child-entity-manager>
  }
</div>









